export class PortalBase {
  constructor(dataStore) {
    this.dataStore = dataStore
  }

  // Returns a promise
  retrieveSection(sectionName) {
    return this.dataStore.retrieveSection(sectionName)
  }

  // Returns a promise
  storeSection(sectionName, section, order) {
    return this.dataStore.storeSection(sectionName, section, order)
  }

  // Returns a promise
  retrieveContent() {
    return this.dataStore.retrieveContent()
  }

  // Returns a promise
  retrieveContentSample() {
    return this.dataStore.retrieveContentSample()
  }

  publishContent() {
    return this.dataStore.publishContent()
  }

  // Returns a promise
  storeContent(content) {
    return this.dataStore.storeContent(content)
  }


  // Returns a promise
  listSections() {
    return this.dataStore.listSections()
  }

  // Returns a promise
  retrieveFileUploadURL(fileName, options) {
    return this.dataStore.retrieveFileUploadURL(fileName, options)
  }

  // Returns a promise
  retrieveFileDownloadURL(fileName, contentDisposition) {
    return this.dataStore.retrieveFileDownloadURL(fileName, contentDisposition)
  }

  // Returns a promise
  listFileUpload() {
    return this.dataStore.listFileUpload()
  }

  // Returns a promise
  removeFileUploadFile(fileName) {
    return this.dataStore.removeFileUploadFile(fileName)
  }

  // Returns a promise
  retrieveMessages(sofId) {
    return this.dataStore.retrieveMessages(sofId)
  }

  retrieveRecentMessages(sofId) {
    return this.dataStore.retrieveRecentMessages(sofId)
  }

  // Returns a promise
  retrieveMessagesAsSOF() {
    return this.dataStore.retrieveMessagesAsSOF()
  }

  // Returns a promise
  sendMessage(sofId, message) {
    return this.dataStore.sendMessage(sofId, message)
  }

  // Returns a promise
  sendMessageAsSOF(companyId, message) {
    return this.dataStore.sendMessageAsSOF(companyId, message)
  }

  storeCriteria(criteia) {
    return this.dataStore.storeCriteria(criteia)
  }

  retrieveCriteria() {
    return this.dataStore.retrieveCriteria()
  }

  searchSOF(queryString, size, from) {
    return this.dataStore.searchSOF(queryString, size, from)
  }

  searchSOFCSV(queryString, size, from) {
    return this.dataStore.searchSOFCSV(queryString, size, from)
  }

}

export default PortalBase